import { defineComponent as _defineComponent } from 'vue'
import { Studio, StudioEvent, SearchParams } from '@/modules/Studios/types'
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'
import { ref, watch, onMounted } from 'vue'
import StudioEventChip from '@/modules/Studios/components/tabs/StudioEventChip.vue'
import { fetchStudioCompetitions } from '@/enitites/studio/api/endpoints'
import Bugsnag from '@bugsnag/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioCompetitionsTab',
  props: {
    studioDetails: null
  },
  setup(__props: any) {

const props = __props as {
  studioDetails: Studio | undefined
};



const competitions = ref<StudioEvent[]>([])
const loading = ref(false)
const sortBy = ref<'date' | 'title'>('date')
const sortDirection = ref<'asc' | 'desc'>('asc')
const pageNumber = ref(0)
const pageSize = ref(100) // Adjust as needed
const keyword = ref('')

const fetchCompetitions = async () => {
  if (!props.studioDetails?.id) return

  loading.value = true
  try {
    const params: SearchParams = {
      pageNumber: pageNumber.value,
      pageSize: pageSize.value,
      keyword: keyword.value,
      sortBy: sortBy.value === 'date' ? 'date' : 'name',
      sortDir: sortDirection.value,
    }

    const fetchedCompetitions = await fetchStudioCompetitions(props.studioDetails.id, params)
    competitions.value = fetchedCompetitions || []
  } catch (error) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
      event.addMetadata('studio', {
        context: 'Error fetching studio competitions',
        studioId: props.studioDetails?.id,
        searchParams: {
          pageNumber: pageNumber.value,
          pageSize: pageSize.value,
          keyword: keyword.value,
          sortBy: sortBy.value,
          sortDir: sortDirection.value,
        },
      })
    })
    competitions.value = []
  } finally {
    loading.value = false
  }
}

watch([sortBy, sortDirection], () => {
  fetchCompetitions()
})

watch(
  () => props.studioDetails?.id,
  () => {
    if (props.studioDetails?.id) {
      fetchCompetitions()
    }
  },
  { immediate: true }
)

onMounted(() => {
  if (props.studioDetails?.id) {
    fetchCompetitions()
  }
})

return { __sfc: true,props, competitions, loading, sortBy, sortDirection, pageNumber, pageSize, keyword, fetchCompetitions, mdiChevronDown, mdiChevronUp, StudioEventChip }
}

})